var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"vd-custom-icon",class:{
		'vd-small': _vm.small,
		'vd-medium': _vm.medium,
		'vd-large': _vm.large,
		'vd-x-large': _vm.xLarge,
		'vd-custom-color': Boolean(_vm.color)
	},style:({
		color: _vm.color,
		width: _vm.size,
		height: _vm.size
	}),attrs:{"aria-hidden":!_vm.label,"aria-label":_vm.label,"role":"img","focusable":"false"}},[_vm._t("default",function(){return [(_vm.themeIcon)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.themeIcon)}}):_vm._e()]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }